import { vuexHandbook } from '@/store/composition/handbook'
import { HookTypeApi } from '@/api/handbook/position/HookType/HookTypeApi'

const state = () => ({
  ...vuexHandbook.createState(),
  api: HookTypeApi
})

const getters = {
  ...vuexHandbook.createGetters()
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
